export default {"src":"/_next/static/media/Chainpass.377de13f.svg","height":21,"width":111,"blurWidth":0,"blurHeight":0};